<template>
  <div class="has-text-centered shorticon" :class="size" :style="`background-color: ${!isEmpty(bgColor) ? bgColor: 'whitesmoke'};`">
    <span class="title" :class="[fontSize, 'has-text-dark']">{{ shortName }}</span>
  </div>
</template>

<script>
  export default {
    props: {
      shortName: {
        type: String,
        default: '--'
      },
      size: {
        type: String,
        default: 'reguler'
      },
      bgColor: {
        type: String,
        default: null
      }
    },

    computed: {
      fontSize() {
        switch(this.size) {
          case 'reguler':
            return 'is-4'
            break;

          case 'large':
            return 'is-2'
            break;

          case 'small':
            return 'is-6'
            break;

          default:
            return 'is-4'
            break;
        }
      }
    }
  }
</script>

<style lang="scss">
  .shorticon {
    align-items: center;
    display: inline-flex;
    justify-content: center;
    border-radius: 3px;

    .title {
      word-break: keep-all;
      font-weight: 700;
    }

    &.reguler {
      height: 58px;
      width: 58px;
    }

    &.small {
      height: 45px;
      width: 45px;
    }

    &.large {
      height: 100px;
      width: 100px;
    }
  }
</style>
